import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { DIMENSION_BY_SIZE } from "@faire/web--source/slate/Avatar/Avatar";
import { ColorTokenKey } from "@faire/web-api--source/indigofair/data/ColorTokenKey";
import React from "react";
import { SDUIImage } from "@faire/retailer/components/SDUI/__internal__/Image/SDUIImage";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
export var SDUIAvatarElementRenderer = function(param) {
    var className = param.className, componentStyle = param.componentStyle, avatarElement = param.avatarElement, renderBehaviour = param.renderBehaviour, loggingData = param.loggingData;
    var _ref = avatarElement !== null && avatarElement !== void 0 ? avatarElement : {}, avatar = _ref.avatar, on_click = _ref.on_click;
    var _ref1 = avatar !== null && avatar !== void 0 ? avatar : {}, image_avatar = _ref1.image_avatar, text_avatar = _ref1.text_avatar, overlay_badge = _ref1.overlay_badge, style = _ref1.style;
    var _ref2 = style !== null && style !== void 0 ? style : {}, _ref_size = _ref2.size, size = _ref_size === void 0 ? "S" : _ref_size, border = _ref2.border;
    var slateWebAvatarSize = getSlateWebAvatarSize(size);
    var avatarIconData = (overlay_badge === null || overlay_badge === void 0 ? void 0 : overlay_badge.image) && overlay_badge.position ? {
        position: getSlateWebAvatarIconPosition(overlay_badge.position),
        icon: /*#__PURE__*/ _jsx(SDUIImage, {
            optimizeImageOptions: {
                width: DIMENSION_BY_SIZE[slateWebAvatarSize] / 2,
                height: DIMENSION_BY_SIZE[slateWebAvatarSize] / 2
            },
            responsiveImage: {
                mobileAndAbove: overlay_badge.image
            },
            renderBehaviour: renderBehaviour
        })
    } : undefined;
    if (!text_avatar && !image_avatar) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        className: className,
        componentStyle: componentStyle,
        children: /*#__PURE__*/ _jsx(Avatar, {
            size: slateWebAvatarSize,
            borderColor: getSlateColorToken(border === null || border === void 0 ? void 0 : border.border_color, ColorTokenKey.COLOR_TOKEN_KEY_UNKNOWN),
            borderStyle: getSlateWebAvatarBorderStyle(border === null || border === void 0 ? void 0 : border.border_style),
            userName: text_avatar,
            image: image_avatar,
            iconData: avatarIconData
        })
    });
};
// mobile uses S,M,L,etc. for avatar sizing, so the proto value needs to be converted from those to Slate web versions
export var getSlateWebAvatarSize = function(size) {
    switch(size){
        case "XXS":
            return "xx-small";
        case "XS":
            return "x-small";
        case "S":
            return "small";
        case "M":
            return "medium";
        case "L":
            return "large";
        case "XL":
            return "x-large";
        default:
            return "medium";
    }
};
var getSlateWebAvatarIconPosition = function(position) {
    switch(position){
        case "TOP_LEFT":
            return "topLeft";
        case "BOTTOM_LEFT":
            return "bottomLeft";
        case "TOP_RIGHT":
            return "topRight";
        case "BOTTOM_RIGHT":
        default:
            return "bottomRight";
    }
};
var getSlateWebAvatarBorderStyle = function(borderStyle) {
    switch(borderStyle){
        case "SLATE_OUTLINED":
            return "OUTLINED";
        case "THIN":
            return "THIN";
        default:
            return undefined;
    }
};
